import { Link } from "react-router";

import { t } from "i18next";

import { Box, Button, Stack, Typography } from "@mui/material";

import { KatsastusLogo } from "@/src/components/atoms";

import {
  katsastusBannerCardSx,
  katsastusBannerCtaButtonSx,
  katsastusBannerDesktopLogoWrapperSx,
  katsastusBannerLogoMobileSx,
  katsastusBannerLogoSx,
  katsastusBannerSectionSx,
  katsastusBannerSubtitleSx,
  katsastusBannerTextStackSx,
  katsastusBannerTitleSx
} from "@/src/pages/consumer/HomePage/components/HomePageKatsastusBanner/katsastusBannerStyles";

import { VehicleType } from "@/src/types/types";

const BANNER_KEY = "consumer.homePage.katsastusBanner";

const KATSASTUS_BANNER_BLOG_PATH =
  "/blog/myy-paremmalla-hinnalla-kuntotutkimus-helpottaa-autoliikkeen-ostopaatosta";

interface HomePageKatsastusBannerProps {
  vehicleType: VehicleType;
}

const HomePageKatsastusBanner = ({
  vehicleType
}: HomePageKatsastusBannerProps) => {
  if (vehicleType !== VehicleType.CAR) return null;

  return (
    <Box sx={katsastusBannerSectionSx}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        sx={[
          { alignItems: "center" },
          ...(Array.isArray(katsastusBannerCardSx)
            ? katsastusBannerCardSx
            : [katsastusBannerCardSx])
        ]}
      >
        <Box sx={katsastusBannerDesktopLogoWrapperSx}>
          <KatsastusLogo variant="square" sx={katsastusBannerLogoSx} />
        </Box>
        <Stack sx={katsastusBannerTextStackSx}>
          <Typography component="p" sx={katsastusBannerTitleSx}>
            {t(`${BANNER_KEY}.title`)}
          </Typography>
          <Typography component="p" sx={katsastusBannerSubtitleSx}>
            {t(`${BANNER_KEY}.subtitle`)}
          </Typography>
        </Stack>
        <Button
          component={Link}
          to={KATSASTUS_BANNER_BLOG_PATH}
          variant="outlined"
          color="primary"
          sx={katsastusBannerCtaButtonSx}
        >
          {t(`${BANNER_KEY}.ctaButton`)}
        </Button>
        <KatsastusLogo variant="wide" sx={katsastusBannerLogoMobileSx} />
      </Stack>
    </Box>
  );
};

export default HomePageKatsastusBanner;
